import $i18n from 'panda-i18n';
export interface pageNumberProps {
  current: number;
  pageSize: number;
}

const IS_NEED = [
  {
    label: $i18n.get({ id: 'Need', dm: '需要' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NoNeed', dm: '不需要' }),
    value: 'N',
  },
];

export { IS_NEED };
